import { render, staticRenderFns } from "./edit-filter-dialog.vue?vue&type=template&id=0aff1ed4&scoped=true&"
import script from "./edit-filter-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-filter-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aff1ed4",
  null
  
)

export default component.exports